import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {

  fetching: false,
  reportingGroup: null,

  updating: false
}

export const actionTypes = {

  fetching: 'reportingGroup/fetching',
  fetched: 'reportingGroup/fetched',
  error: 'reportingGroup/error',

  updating: 'reportingGroup/updating',
  updated: 'reportingGroup/updated',
  created: 'reportingGroup/created'
}

export const actionCreators = {

  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching, data: id })
    context.api.reportGroupsService.get(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  update: (dto) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.reportGroupsService.update({ ...dto, templates: null, templateVersionIds: [...dto.templates.map(x => x.id)] }, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.updated, data: { ...response, templates: [...dto.templates] } })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  },
  create: (dto, refreshGrid) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.reportGroupsService.create({ ...dto, templates: null, templateVersionIds: [...dto.templates.map(x => x.id)] }, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.created, data: { ...response, templates: [...dto.templates] } })
        refreshGrid()
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, reportingGroup: action.data }
    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false, reportingGroup: action.data }
    case actionTypes.created: return { ...state, updating: false, reportingGroup: action.data }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportingGroups.js